//import React from 'react';
import { checkUrl } from './src/services/checkUrl'

export const onClientEntry = () => checkUrl();